import { IsArray, IsBoolean, IsOptional, IsString } from 'class-validator';

/** The search indexes a tenant can have provisioned (PD-17067: + contact, PD-14959: + global_search). */
export type SearchIndexEntityTypeModel = 'client' | 'item' | 'user' | 'contact' | 'global_search';

export class ProvisionSearchIndexesDto {
	@IsArray()
	@IsString({ each: true })
	public tenantAliases!: Array<string>;

	@IsArray()
	@IsString({ each: true })
	public entityTypes!: Array<SearchIndexEntityTypeModel>;

	@IsOptional()
	@IsBoolean()
	public runBulkIndex?: boolean;
}
